/*
 * @Author       : 程哲林
 * @Date         : 2022-05-25 17:25:14
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-05-24 19:12:12
 * @FilePath     : /marketing-landing-fe/src/locales/zh_CN/index.ts
 * @Description  : 未添加文件描述
 */
export default {
  // 地区滚轮选择器操作文案。
  'cascadingPicker.cancel': 'Cancel',
  'cascadingPicker.confirm': 'Confirm',
  'money.symbol': '¥',
  'userEvt.title': '用户评价',
  'global.check': '查看全部',
  'userEvt.all': '全部',
  'userEvt.effect': '效果好',
  'userEvt.content': '内容好',
  'userEvt.baby': '孩子喜欢',
  'userEvt.service': '服务好',
  'userEvt.costEffective': '性价比高',
  'userEvt.none': '没有更多数据了',
  'userEvt.loading': '正在加载数据',
  'landing.page.title': 'JoJo',
  'courseSelection.config.title': 'Confirm Order',
  'courseSelection.phone.title': 'Account',
  'courseSelection.phone.name': 'Phone Number',
  'courseSelection.phone.tip': 'Used for claiming trial packages',
  'courseSelection.phone.tip1': 'Encrypted',
  'courseSelection.telephonecode.title': '选择国家/地区',
  'courseSelection.telephonecode.commonly': '常用国家/地区',
  'courseSelection.telephonecode.other': '其他国家/地区',
  'courseSelection.phone.placeholder': '手机号仅作为体验凭证',
  'courseSelection.code.placeholder': '请输入验证码',
  'courseSelection.code.resend': '重新发送',
  'courseSelection.code.btn': '获取验证码',
  'courseSelection.pack.title': '商品信息',
  'courseSelection.pack.title2': '请根据孩子的年级进行选择',
  'courseSelection.pack.desc1': '科学体系',
  'courseSelection.pack.desc2': '每天15分钟',
  'courseSelection.pack.payment1': '支付后请及时进入社群获得体验包信息',
  'courseSelection.pack.payment2': '支付后请按照页面提示获得体验包信息',
  'courseSelection.pack.tips1': '领取后请及时进入社群获得体验包信息',
  'courseSelection.pack.tips2': '领取后请按照页面提示获得体验包信息',
  'courseSelection.buy.btn': 'Buy now',
  'courseSelection.free.btn': 'Free to claim',
  'courseSelection.receive.btn': 'Claim for {{yuan}} yuan',
  'courseSelection.receive.unavailable': 'Temporarily unavailable for purchase',
  'courseSelection.buy.type': '支付方式',
  'courseSelection.buy.wechat': '微信支付',
  'courseSelection.select.text': '已选',
  'courseSelection.toast.correctPhone': '请输入正确的手机号',
  'courseSelection.toast.codeFail': '获取验证码失败',
  'courseSelection.toast.receivedIt': '系统异常，请稍后重试',
  'courseSelection.toast.previewFailed': '预览页面不能继续',
  'courseSelection.toast.enterInfo': '请输入手机号等信息',
  'courseSelection.toast.loading': 'Wait',
  'courseSelection.toast.autoVerPhone': '手机号自动校验中...',
  'courseSelection.toast.codeErr': '验证码格式错误',
  'courseSelection.toast.codeErr2': '验证码错误',
  'courseSelection.toast.dataErr': '数据错误：没有售卖单id',
  'courseSelection.toast.systemErr': '系统开小差啦，请稍后再试',
  'courseSelection.toast.systemErr2': 'Something went wrong. Please try again later.',
  'courseSelection.toast.payFail': '支付失败!',
  'courseSelection.toast.rePay': '您还没有支付哦，请重新支付。',
  'courseSelection.toast.dataErr2': '数据获取错误',
  'courseSelection.app.desc': '长按识别小程序码',
  'courseSelection.app.desc1': '您已经体验过体验包了',
  'courseSelection.app.desc2': '可前往下方小程序回顾',
  'courseSelection.prompt.titleFail': '体验包领取失败',
  'courseSelection.prompt.ctAlreadyReceived': '3天内有体验过的体验包，此时更适合复习回顾哦',
  'courseSelection.prompt.btnKnow': 'Got it',
  'courseSelection.prompt.btnActivate': '激活内容',
  'courseSelection.prompt.titleHint': '提示',
  'courseSelection.prompt.titleEnd': '报名已结束',
  'courseSelection.prompt.titleHint2': '温馨提示',
  'courseSelection.prompt.ctStart': '下期报名即将开始',
  'courseSelection.prompt.ctSellOut': '抱歉，商品已售罄',
  'courseSelection.prompt.titleRecur': '您已有同类内容',
  'courseSelection.prompt.titleNotActivated': '您还有未激活的体验包哦',
  'courseSelection.prompt.switchAccounts': '请用主账户领取体验包',
  'courseSelection.prompt.ctAlreadyReceived2': '您已经领过啦',
  'courseSelection.prompt.ctNotSatisfied': '抱歉，您不满足新用户领取规则，请退款后前往“爱阅读的叫叫”公众号领取',
  'courseSelection.prompt.dissatisfied': '抱歉，您不满足新用户领取规则，请退款后前往“爱阅读的叫叫”公众号领取',
  'btnButton.btn.txt2': '单独购买',
  'btnButton.btn.txt3': '一键参团',
  'btnButton.tips.joinGroup': '发现超值参团，已为您自动参团哦',
  'askEveryone.title': '问大家',
  'askEveryone.reply': '个回答',
  'group.title': '人正在拼团，可直接参团',
  'group.difference': '仅差1人成团',
  'group.btn.join': '去参团',
  'group.time.left': '剩余',
  'phone.register': '已报名',
  'phone.register.time': '分钟',
  'prompt.title.packageNotActivated': '您还有未激活的体验包哦',
  'prompt.title.failedToClaim': '体验包领取失败',
  'prompt.title.hint': '提示',
  'prompt.content.review': '7天内有体验过的体验包，此时更适合复习回顾哦',
  'prompt.content.received': '您已经领过啦',
  'prompt.btn.activation': '激活内容',
  'prompt.btn.know': '知道了',
  'prompt.413Error': '网络异常，请再次输入手机号和获取验证码后重试',
  'payQrCode.alipay': '支付宝',
  'payQrCode.wechat': '微信',
  'payQrCode.pay': '扫码支付',
  'payQrCode.tips': '若本设备未安装{payTxt}，请使用已安装{payTxt}的设备扫码支付',
  'prePayPage.paySuccess': '支付成功',
  'prePayPage.payFail': '支付失败，请重新扫码',
  'prePayPage.payUseWx': '请使用微信扫码',
  'customerService.inline': '客服',
  'customerService.standalone': '联系客服'
};